export default {"src":"/_next/static/media/save-icon.0bec5f88.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};